module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Of Woe, Wonder and Whimsy")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About The Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#the-bowling-green-stewart-utterthwaite"
    }
  }, [_vm._v("The Bowling Green! (Stewart Utterthwaite!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#savage-revenge-the-wind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savage Revenge! (The Wind!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#pillars-of-sand-fred-walker",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pillars of Sand! (Fred Walker!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#spring-the-hawthorn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring! (The Hawthorn!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-snowflake-winter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Snowflake! (Winter!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#summer-a-favourite-place",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer! (A Favourite Place!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#stony-lane-molly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stony Lane! (Molly!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#sticky-fingers-norbert-ramage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sticky Fingers! (Norbert Ramage!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#dust-to-dust-maggie-habergam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dust to Dust! (Maggie Habergam!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#the-weights-of-space-great-mans-head-hill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Weights of Space! (‘Great Man’s Head Hill’!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#and-hopes-sprang-external-the-531",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And Hopes Sprang External! (The 531!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#the-hillbeast-stewart-utterthwaite-again",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hillbeast! (Stewart Utterthwaite Again!)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#that-gap-before-the-bridge-autumn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That Gap Before the Bridge! (Autumn!)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0